import { yup } from '@framework/validation';

/**
 * Schema di sola visualizzazione: i campi non vengono mai validati né inviati,
 * ma servono al `FormHandler` per popolare i `TextInput` in sola lettura,
 * riusando lo stesso linguaggio grafico del Profilo PF.
 */
export const LegalEntityProfileDisplaySchema = yup.object({
  ragioneSociale: yup.string().nullable(),
  partitaIva: yup.string().nullable(),
  tipo: yup.string().nullable(),
  stato: yup.string().nullable(),
  pec: yup.string().nullable(),
  sedeLegale: yup.string().nullable(),
  operatorEmail: yup.string().nullable(),
  operatorNome: yup.string().nullable(),
  operatorCognome: yup.string().nullable(),
});
